import LoadStylesService from '../../../shared/services/LoadStylesService';
import MediaQueries from '../../../shared/helpers/MediaQueries';

/**
 * Load Search Algolia dynamically
 */
export default class SearchChunk {
  static body: HTMLElement;

  static header: HTMLElement;

  static styleCreatedPrimary = false;

  static styleCreated = false;

  constructor() {
    SearchChunk.header = document.querySelector('.l-header');
    SearchChunk.body = document.querySelector('body');

    // Load CSS primary popin search
    if (!SearchChunk.styleCreatedPrimary) {
      SearchChunk.loadStylesSearchPopinPrimary();
    }

    // Load old JS basics
    if (SearchChunk.body.classList.contains('l-search')) {
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-searchLoadScript' */ '../../../../../../assets/js/modules/search/searchLoadScript'
      ).then();
    }

    /* Load Search Algolia to click in search field */
    document.addEventListener(
      'click',
      (event) => {
        if (
          event.target instanceof HTMLElement &&
          !SearchChunk.header.classList.contains('import-search-js')
        ) {
          const searchContainerElement = event.target;

          // New header & Old header
          if (
            searchContainerElement &&
            (searchContainerElement.classList.contains('js-searchAll') ||
              searchContainerElement.classList.contains('picto-search') ||
              searchContainerElement.closest('#js-start-search') ||
              (searchContainerElement.parentElement &&
                searchContainerElement.parentElement.id === 'start-search'))
          ) {
            SearchChunk.importSearchClick(event, searchContainerElement);
          }
        }
      },
      { passive: true }
    );
  }

  /**
   * Load Search Algolia to click
   *
   * @param {Event} event - Click event
   * @param {HTMLElement} clickElement - Click event
   */
  private static importSearchClick(event: Event, clickElement: HTMLElement) {
    const elementLoader = '.c-inputSearch';
    const loaderInput: HTMLElement = document.querySelector(elementLoader);

    // New header
    if (
      loaderInput &&
      !SearchChunk.header.classList.contains('js-search--clickLoaded')
    ) {
      loaderInput.classList.add('is-loading');

      SearchChunk.dynamicImportSearch();

      // Load CSS popin search
      if (!SearchChunk.styleCreated) {
        SearchChunk.loadStylesSearchPopin();

        // Add an event listener
        document.addEventListener('load-search-css', (e: CustomEvent) => {
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-searchLoadScript' */ '../../../../../../assets/js/modules/search/searchLoadScript'
          ).then(() => {
            loaderInput.classList.remove('is-loading');
          });
        });
      }
    }
  }

  static dynamicImportSearch() {
    /* Import old chunk search */
    import(
      /* webpackPreloading: true */ /* webpackChunkName: 'preload-search' */ '../../../../../../assets/js/modules/search/searchChunk'
    ).then(({ default: searchChunk }) => {
      // eslint-disable-next-line new-cap
      new searchChunk();

      let elementSearch = '.js-searchAll';

      // For Mobile
      if (MediaQueries.mobileMedia.matches && elementSearch === '.searchAll') {
        elementSearch = '.second-container-mobile .search-button';
      }

      const searchElement: HTMLInputElement =
        document.querySelector(elementSearch);

      if (
        searchElement &&
        !SearchChunk.header.classList.contains('js-search--clickLoaded')
      ) {
        SearchChunk.header.classList.add('js-search--clickLoaded');
        searchElement.click();
      }
    });
  }

  /**
   * Load styles Primary in popup search
   */
  static loadStylesSearchPopinPrimary() {
    const { cssFileSearchPrimary } = SearchChunk.header.dataset;

    if (
      !SearchChunk.header.classList.contains('js-search--cssLoadedPrimary') &&
      !SearchChunk.body.classList.contains('l-search')
    ) {
      SearchChunk.header.classList.add('js-search--cssLoadedPrimary');
      SearchChunk.styleCreatedPrimary =
        LoadStylesService.loaderStyle(cssFileSearchPrimary);
    }
  }

  /**
   * Load all styles in popup search
   */
  static loadStylesSearchPopin() {
    const { cssFileSearch } = SearchChunk.header.dataset;

    if (
      !SearchChunk.header.classList.contains('js-search--cssLoaded') &&
      !SearchChunk.body.classList.contains('l-search')
    ) {
      SearchChunk.header.classList.add('js-search--cssLoaded');
      SearchChunk.styleCreated = LoadStylesService.loaderStyle(
        cssFileSearch,
        '',
        true
      );
    }
  }
}
